/* istanbul ignore file */
import {getColorCssVars} from '@wix/wixstores-client-storefront-common';
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';

export const getStickyButtonContainerCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const productPage_stickyDrawerBackgroundColor = styleParams.colors?.productPage_stickyDrawerBackgroundColor;
  const colorVars = getColorCssVars('stickyDrawerBackgroundColor', productPage_stickyDrawerBackgroundColor);
  const rgb = colorVars['stickyDrawerBackgroundColor-rgb'];

  return {stickyDrawerBackgroundColor: rgb ? `${rgb}, 1` : 'var(--wix-color-1)'};
};
